import SitecoreModeService from '../../services/sitecore-mode-service'

export default {
  sitecoreModeService: SitecoreModeService,
  keyAttributeName: 'key',
  tempKeyAttributeName: 'data-phkey',

  InitialiseVueApp(initialiseVueApp) {
    this.BuildSitecorePlaceholderMap()
    initialiseVueApp()
    this.EnsureSitecorePlaceholderKeys()
  },

  BuildSitecorePlaceholderMap() {
    if (this.sitecoreModeService.IsExperienceEditor()) {
      let pagePlaceholders = Array.from(document.querySelectorAll(`code[${this.keyAttributeName}]`))
      pagePlaceholders = pagePlaceholders.concat(this.GetPlaceholdersFromTemplateList(document.querySelectorAll('template')))

      this.CopyElementsAttribute(pagePlaceholders, this.keyAttributeName, this.tempKeyAttributeName)
    }
  },

  EnsureSitecorePlaceholderKeys() {
    if (this.sitecoreModeService.IsExperienceEditor()) {
      let pagePlaceholders = Array.from(document.querySelectorAll(`code[${this.tempKeyAttributeName}]`))
      pagePlaceholders = pagePlaceholders.concat(this.GetPlaceholdersFromTemplateList(document.querySelectorAll('template')))

      this.CopyElementsAttribute(pagePlaceholders, this.tempKeyAttributeName, this.keyAttributeName, true)
    }
  },

  CopyElementsAttribute(elements, fromAttributeName, toAttributeName, removeFromAttribute = false) {
    elements.forEach(placeholder => {
      placeholder.setAttribute(toAttributeName, placeholder.getAttribute(fromAttributeName) || '')

      if (removeFromAttribute) {
        placeholder.removeAttribute(fromAttributeName)
      }
    })
  },

  GetPlaceholdersFromTemplateList(templateList) {
    let placeholders = []

    const findPlaceholders = (element) => {
      // Adiciona placeholders do elemento atual
      const currentPlaceholders = Array.from(element.querySelectorAll(`code[${this.keyAttributeName}]`))
      placeholders = placeholders.concat(currentPlaceholders)

      // Chama recursivamente para cada filho que também é um template
      const childTemplates = Array.from(element.querySelectorAll('template'))
      childTemplates.forEach(template => {
        findPlaceholders(template.content)
      })
    }

    if (templateList.length <= 0) {
      return []
    }

    templateList.forEach(vueTemplate => {
      findPlaceholders(vueTemplate.content)
    })

    return placeholders
  }
}
